<template>
<div class="container pt-6 pl-6 pt-md-5 h-100 p-relative">
  <div class="py-md-4">
  </div>
  <h2 class="font-size-2_5rem tracking-1 text-center mb-5 d-none d-md-block">BRAND</h2>
  <h2 class="d-md-none mobile-section-title">BRAND</h2>
  <div class="brand-wrapper">
    <div class="p-relative" :style="brandContentStyle">
      <b-row>
        <b-col v-for="(brand, i) in brands" :key="brand.id" cols="12" sm="6" lg="4" class="mb-2 mb-md-4">

          <b-button variant="outline-dark" block @click="clickBrand(i)">
            {{ brand.name }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div><!-- /.brand-wrapper -->

</div><!-- /.container -->
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      // brands: null,
      showP2: false
    }
  },
  mounted() {
    // this.getBrands()
    if(!this.brands) {
      console.log('brandないよ')
      this.fetchBrands()
    } else {
      console.log('brandあるよ')
    }
  },
  computed: {
    ...mapState({
      brands: state => state.brands,
      brandMobileP2Showing: state => state.brandMobileP2Showing,
    }),
    brandContentStyle() {
      if (this.showP2) {
        return {
          top: '-294px'
        }
      } else {
        return {
          top: '0px'
        }
      }
    }
  },
  watch: {
    brandMobileP2Showing(val) {
      this.showP2 = val 
    }
  },
  methods: {
    async fetchBrands() {
      await this.syncBrands(this.axios)
    },
    ...mapActions({
      syncBrands: 'syncBrands',
      setBrandNavigationShowing: 'doSetBrandNavigationShowing'
    }),
    clickBrand(i) {
      this.setBrandNavigationShowing(true)
      this.$router.push({name: 'Brand', params: {brandArrayIndex: ''+i}})
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-sky {
  color: #fff;
  @media screen and (min-width: 768px){
    color: #333;
  }
}
.mobile-title {
  font-size: 1.5rem;
  @media screen and (min-width: 768px){
    font-size: 0.85rem;
  }
}
.brand-wrapper {
  height: calc(100vh - 100px);
  overflow: hidden;
  >div {
    transition: top 0.6s;
  }
}
.footer-control {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
}
</style>